// Constants
import { WIDTH, HEIGHT } from 'components/kit/waveform/constants'

// Types
import { Loop } from 'types'

import styles from './loopblock.css'

type LoopBlockProps = {
  barIndex: number
  barPositions?: Array<number> | null
  beatsPerBar: number
  duration: number
  loop: Loop
  datatesting?: string
}

const LoopBlock = ({ barPositions, duration, loop, beatsPerBar, barIndex, datatesting }: LoopBlockProps): JSX.Element | null => {
  const startBarTime = barPositions ? barPositions[barIndex] : loop.time_start
  const endBarTime = barPositions ? barPositions[barIndex + loop.beat_count / beatsPerBar] : loop.time_end
  const x = ((startBarTime || 1) / duration) * WIDTH
  const endX = ((endBarTime || 1) / duration) * WIDTH
  const outOfBounds = !(barPositions ? barPositions[barIndex + loop.beat_count / beatsPerBar] : loop.time_end)
  return !outOfBounds ? (
    <polygon points={`${x},0 ${endX},0 ${endX},${HEIGHT} ${x},${HEIGHT}`} className={styles.block} datatesting={datatesting} />
  ) : null
}

export default LoopBlock
